import { Component } from "@angular/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzTableModule } from "ng-zorro-antd/table";
import { AuthService } from "../../services/auth/auth.service";

@Component({
    selector: 'app-unauthorized-access',
    standalone: true,
    imports: [
        NzTableModule,
        NzButtonModule,
        NzSelectModule,
        NzGridModule,
        NzSpaceModule,
        NzResultModule
    ],
    templateUrl: './unauthorized-access.component.html',
    styleUrls: ['./unauthorized-access.component.scss']
})
export class UnauthorizedAccessComponent {
    constructor(public authService: AuthService) {}
}
